import React, { useState } from 'react'
import { Layout, Form, Input, Button, message } from 'antd'
import { getUUID, setUUID, getToken } from '../../auth-provider'
import { Redirect } from 'react-router-dom'
import Foot from '../../components/Foot'
import './index.less'
import { smsRequest } from '../../service/captcha'
import { useAuth } from '../../context/auth-context'
const { Content } = Layout

// 从路由参数拿到重定向地址，从redux获取登录状态和登录方法
const LoginView = props => {
  const { login } = useAuth()
  const [isDisabled, setIsDisabled] = useState('')
  const [form] = Form.useForm()
  const redirect = props.location.state?.redirect || '/'

  if (getToken()) {
    return <Redirect to={redirect}></Redirect>
  }

  // 自定义密码验证规则
  const validatePassword = (_, value) => {
    // 规则1：至少6位
    if (value && value.length < 6) {
      return Promise.reject(new Error('密码不能少于6位'));
    }
    
    // 规则2：必须同时包含字母和数字
    if (!/(?=.*[a-zA-Z])(?=.*\d)/.test(value)) {
      return Promise.reject(new Error('密码必须包含字母和数字'));
    }
    
    return Promise.resolve();
  };
  const onFinish = values => {
    login(values)
    // .then(reponse => {
    //   console.log(reponse)
    //   const data = reponse.data
    //   if (data.code === 200) {
    //     const token = data.data
    //     setToken(token)
    //     // console.log('finsi')
    //     // console.log(getToken())
    //     getToken() && props.history.push(redirect)
    //   } else {
    //     data.message && message.warning(data.message)
    //   }
    // })
    // .catch(error => {
    //   console.log(error)
    // })
  }
  return (
    <Layout>
      <Content>
        <div className="main-wrap">
          {/* <div className="login-header">
            <NavLink to="/" replace>
              课题申报网
            </NavLink>
          </div> */}
          <div className="login-content-warp">
            <h2 className="login-title">登录</h2>
            <div className="login-wrap">
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                form={form}
                onFinish={onFinish}
              >
                <Form.Item
                  name="contactPhone"
                  rules={[
                    {
                      // pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                      required: true,
                      message: '请输入正确的手机号!',
                    },
                  ]}
                >
                  <Input addonBefore="+86" placeholder="11位手机号" />
                </Form.Item>
                 <Form.Item
                        name="captcha"
                        rules={[
                          {
                            required: true,
                            message: '请输入密码',
                          },
                          { validator: validatePassword } 
                        ]}
                      >
                      <Input.Password placeholder="至少6位字母+数字组合" />
                      </Form.Item>
              
                <p style={{ textAlign: 'center' }}>
                  无需注册，使用手机号一键登录,密码必须包含字母和数字组合，至少6位以上。
                </p>
                <Form.Item>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    登录
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </Content>
      <Foot />
    </Layout>
  )
}
export default LoginView
